
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50.5 50.499"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".5"}},[_c('path',{attrs:{"d":"M5.25 25.25h9M8.25 28.25l-3-3 3-3"}})]),_c('g',{attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".5"}},[_c('path',{attrs:{"d":"M.25 2.424A2.175 2.175 0 012.424.25h45.652a2.175 2.175 0 012.174 2.174v45.652a2.174 2.174 0 01-2.174 2.173H2.424A2.174 2.174 0 01.25 48.076z","stroke":"#000"}}),_c('path',{attrs:{"d":"M8.659 14.815h33.183M12.599 35.684h25.3M17.793 42.249h14.914M17.793 25.25h14.914M17.793 8.25h14.914","stroke":"currentColor"}})]),_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".5"}},[_c('path',{attrs:{"d":"M42.25 28.25l3-3-3-3M36.25 25.25h9"}})])])
          )
        }
      }
    